<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} bot
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="nombre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje de menú -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje de menú"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.menu_message"
                    :error-messages="errors"
                    label="Mensaje de menú"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje de retorno -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje de respuesta"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.return_message"
                    :error-messages="errors"
                    label="Mensaje de respuesta"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje inicial -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje inicial"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.initial_message"
                    :error-messages="errors"
                    label="Mensaje inicial"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje de despedida -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje de despedida"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.goodbye_message"
                    :error-messages="errors"
                    label="Mensaje de despedida"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Longitud -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="tiempo de cierre"
                  rules="required|integer"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.closing_time_sg"
                    :error-messages="errors"
                    label="Tiempo de cierre (Segundos)"
                    type="number"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Cola -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="cola de cierre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.closing_queue"
                    :items="queueList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Cola de cierre"
                    filled
                    rounded
                    class="rounded-lg"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        two-line
                        selectable
                        v-on="on"
                        v-bind="attrs"
                        class="pl-3"
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
    parentId: {
      type: Number,
      default: null,
      required: true,
    },
    whatsappId: {
      type: Number,
      default: null,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      queueList: [],
      clientList: [],
      whatsappLineList: [],
      payload: {
        name: "",
        menu_message: "",
        return_message: "",
        initial_message: "",
        closing_time_sg: null,
        goodbye_message: "",
        closing_queue: null,
      },
    };
  },

  computed: {
    isEditMode() {
      return !!this.dataToEdit.id;
    },
  },

  created() {
    this.getSelectsInfo();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.menu_message = "";
      this.payload.return_message = "";
      this.payload.initial_message = "";
      this.payload.closing_time_sg = null;
      this.payload.goodbye_message = "";
      this.payload.closing_queue = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data, this.isEditMode);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [
        "/clients/index_whatsapp",
        "/whatsapps/index_select_whatsapp",
      ];

      await axios
        .all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)))
        .then((res) => {
          this.queueList = res[0].data.data;
          this.whatsappLineList = res[1].data;
          // console.log("Listo", res);
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      const { id, ...payload } = this.payload;
      payload.whatsapp_id = this.whatsappId;
      payload.option_id = this.parentId;
      payload.use = false;

      const url = this.isEditMode ? `/whatsapps/bot/${id}` : "/whatsapps/bot";
      const method = this.isEditMode ? "put" : "post";

      try {
        const { data } = await PbxHttpClient[method](url, payload);
        this.closeDialog(data.bot);

        this.$snotify.success(
          `Bot ${this.isEditMode ? "actualizado" : "creado"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
